<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Skeleton } from '../Skeleton';

	interface Props {
		lines?: 1 | 2 | 3;
		dataCy: string;
		classes?: { image?: string };
	}

	let { lines = 1, dataCy, classes = {} }: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-artwork-card-loading`);
</script>

<div data-cy={dataCyPrefix}>
	<Skeleton variant="rectangular" class={twMerge('h-[300px] w-full', classes.image)} />

	<div class="flex flex-col gap-3 p-4">
		<Skeleton class="h-[20px]" />

		{#if lines >= 2}
			<Skeleton class="h-[16px] w-[70%]" />
		{/if}

		{#if lines === 3}
			<Skeleton class="h-[16px] w-[40%]" />
		{/if}
	</div>
</div>
